module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/My-Dinner-With-Herve.8d4254f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/My-Dinner-With-Herve.jpg
// module id = a1Pu
// module chunks = 0